import { render, staticRenderFns } from "./SummaryBit.vue?vue&type=template&id=7654208c&"
import script from "./SummaryBit.vue?vue&type=script&lang=js&"
export * from "./SummaryBit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports